<template>

	<!-- Main Container -->
	<div class="main-container">
		<div class="course-management-page">
			<div class="management-header">
				<div>
					<h1 class="page-title">课程管理</h1>
					<p class="page-subtitle">管理专业课程体系，可自由添加、编辑和删除课程</p>
				</div>
			</div>

			<div v-for="(item, index) in list" :key="index" class="category-section">
				<div class="category-header">
					<div class="category-title">
						<!-- <span>{{ item.icon }}</span> -->
						{{ item.fileName }}
						<!-- <span class="category-count">{{ getCategoryCount(index) }}</span> -->
					</div>
				</div>
				<div class="course-list">
					<div v-for="(course,indexs) in item.list" :key="course.id" class="course-item">
						<div class="course-header">
							<div>
								<div class="course-name">{{ course.originalName }}</div>
								<div class="course-code">{{ course.category }}</div>
							</div>
							<div class="course-actions">
								<button class="action-btn edit" @click="editCourse(course, item.id)" title="编辑课程">
									✏️
								</button>
								<!-- <button class="action-btn materials" @click="manageMaterials(course.id)"
										title="管理教材">
										📚
									</button> -->
								<button class="action-btn delete" @click="deleteCourse(course.id, index,indexs)"
									title="删除课程">
									🗑️
								</button>
							</div>
						</div>
						<div class="course-desc">{{ course.remark || course.content }}</div>
						<div class="course-stats">
							<span>📚 {{ course.fileNum || 0 }} 个教材</span>
							<span>📅 最近更新：{{course.uploadTime}}</span>
						</div>
					</div>
					<div class="add-course-item" @click="addCourseToCategory(item.id)">
						<div class="add-icon">➕</div>
						<div class="add-text">添加新课程</div>
					</div>
				</div>
			</div>

			<!-- Course Modal -->
			<div class="modal-overlay" :class="{ show: showModal }" @click="closeModal">
				<div class="modal" @click.stop>
					<div class="modal-header">
						<h2 class="modal-title">{{ isEditing ? '编辑课程' : '添加课程' }}</h2>
						<p class="modal-subtitle">填写课程基本信息</p>
					</div>
					<div class="modal-body">
						<form @submit.prevent="saveCourse">
							<div class="form-group">
								<label class="form-label">课程分类</label>
								<el-select class="form-el-select" v-model="courseForm.parentId" :disabled="true">
									<el-option :value="item.id" v-for="item in list" :key="item.id"
										:label="item.fileName">{{item.fileName}}</el-option>
								</el-select>
							</div>
							<div class="form-group">
								<label class="form-label">课程名称</label>
								<input type="text" class="form-input" v-model="courseForm.folderName"
									placeholder="请输入课程名称" required>
							</div>
							<div class="form-group">
								<label class="form-label">课程代码</label>
								<input type="text" class="form-input" v-model="courseForm.category"
									placeholder="例如：010101" required>
							</div>
							<div class="form-group">
								<label class="form-label">课程描述</label>
								<textarea class="form-textarea" v-model="courseForm.content" placeholder="请简要描述课程内容和目标"
									required></textarea>
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button class="btn btn-secondary" @click="closeModal">取消</button>
						<button class="btn btn-primary" @click="saveCourse">{{ isEditing ? '保存' : '添加' }}课程</button>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	export default {
		name: 'CourseManagementPage',
		components: {},
		data() {
			return {
				categories: [], //课程分类
				list: [], //数据
				showModal: false,
				isEditing: false,
				editingCourse: null,
				editingCategory: null,
				courseForm: {
					parentId: '',
					folderName: '',
					category: '',
					content: ''
				},
			}
		},
		mounted() {
			this.courseClassification();
		},
		computed: {
			...mapGetters([
				'currentUser'
			]),
		},
		methods: {
			async courseClassification() {
				try {
					const categories = await this.HttpUtils.get('/api/system/gjfilecategory/level1', {});
					this.categories = categories.data.data;

					const filePromises = this.categories.map(category =>
						this.HttpUtils.get(`/api/system/gjfilecategory/subcategory/${category.id}`, {})
						.then(files => ({
							id: category.id,
							fileName: category.fileName,
							list: files.data.data
						}))
					);
					const results = await Promise.all(filePromises);
					console.log('整合数据', results)
					// 4. 整合数据
					this.list = results;

				} catch (error) {
					console.error('获取数据失败:', error);
				}
			},
			showAddCourseModal(id) {
				this.resetForm()
				this.courseForm.parentId = id
				this.showModal = true
			},
			addCourseToCategory(id) {
				this.showAddCourseModal(id)
			},
			editCourse(course, id) {
				console.log(course)
				this.isEditing = true
				//this.editingCourse = course
				//this.editingCategory = index
				this.courseForm = {
					parentId: id,
					id: course.id,
					folderName: course.fileName,
					category: course.category,
					content: course.remark || course.content
				}
				this.showModal = true
			},
			deleteCourse(courseId, index, indexs) {
				this.$confirm('确定要删除这门课程吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.HttpUtils.delete('/api/system/gjfilecategory/file/' + courseId, {}).then(res => {
						console.log(res)
						if (res.data.code === 200) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.list[index].list.splice(indexs, 1);
							//this.courseClassification()
						} else {
							this.$message.error(res.data.msg)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			saveCourse() {
				if (!this.courseForm.folderName || !this.courseForm.category || !this.courseForm.content) {
					this.$message({
						message: '请填写完整的课程信息',
						type: 'warning'
					});
					return
				}

				if (this.isEditing) {

					console.log(this.courseForm.id)
					this.HttpUtils.put('/api/system/gjfilecategory/file/' + this.courseForm.id, {
						originalName: this.courseForm.folderName,
						category: this.courseForm.category,
						content: this.courseForm.content
					}).then(res => {
						console.log(res)
						if (res.data.code === 200) {
							this.$message({
								message: '编辑成功',
								type: 'success'
							});
							this.courseClassification()
							this.closeModal()
						} else {
							this.$message.error(res.data.msg)
						}
					})
				} else {
					this.HttpUtils.post('/api/system/gjfilecategory/folder', {
						userId: this.currentUser.userId,
						parentId: this.courseForm.parentId,
						folderName: this.courseForm.folderName,
						category: this.courseForm.category,
						content: this.courseForm.content
					}).then(res => {
						console.log(res)
						if (res.data.code === 200) {
							this.$message({
								message: '添加成功',
								type: 'success'
							});
							this.courseClassification()
							this.closeModal()
						} else {
							this.$message.error(res.data.msg)
						}
					})
				}
			},
			closeModal() {
				this.showModal = false
				this.resetForm()
			},
			resetForm() {
				this.isEditing = false
				//this.editingCourse = null
				//this.editingCategory = null
				this.courseForm = {
					parentId: '',
					folderName: '',
					category: '',
					content: '',
				}
			},

		}
	}
</script>

<style scoped>
	.course-management-page .management-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 32px;
	}

	@media (max-width: 768px) {
		.course-management-page .management-header {
			flex-direction: column;
			align-items: flex-start;
			gap: 16px;
		}
	}

	.course-management-page .page-title {
		font-size: 32px;
		font-weight: 800;
		color: #111827;
		margin-bottom: 8px;
	}

	.course-management-page .page-subtitle {
		font-size: 16px;
		color: #6B7280;
	}

	.course-management-page .management-actions {
		display: flex;
		gap: 12px;
	}

	.course-management-page .category-section {
		background: white;
		border-radius: 24px;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
		padding: 24px;
		margin-bottom: 24px;
		border: 1px solid #E5E7EB;
	}

	.course-management-page .category-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.course-management-page .category-title {
		font-size: 20px;
		font-weight: 700;
		color: #111827;
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.course-management-page .category-count {
		background: #E5E7EB;
		color: #6B7280;
		padding: 4px 12px;
		border-radius: 100px;
		font-size: 12px;
		font-weight: 600;
	}

	.course-management-page .course-list {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
		gap: 16px;
	}

	@media (max-width: 1024px) {
		.course-management-page .course-list {
			grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
		}
	}

	@media (max-width: 768px) {
		.course-management-page .course-list {
			grid-template-columns: 1fr;
		}
	}

	.course-management-page .course-item {
		background: #F9FAFB;
		border: 2px solid #E5E7EB;
		border-radius: 12px;
		padding: 20px;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		position: relative;
	}

	.course-management-page .course-item:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
		border-color: #60A5FA;
	}

	.course-management-page .course-item:hover .course-actions {
		opacity: 1;
	}

	.course-management-page .course-header {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		margin-bottom: 12px;
	}

	.course-management-page .course-name {
		font-size: 16px;
		font-weight: 600;
		color: #111827;
		margin-bottom: 4px;
	}

	.course-management-page .course-code {
		font-size: 12px;
		color: #6B7280;
		background: #E5E7EB;
		padding: 2px 8px;
		border-radius: 4px;
		display: inline-block;
	}

	.course-management-page .course-actions {
		display: flex;
		gap: 4px;
		opacity: 0;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.course-management-page .action-btn {
		width: 32px;
		height: 32px;
		border: none;
		border-radius: 6px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.course-management-page .action-btn.edit {
		background: #2E5CE6;
		color: white;
	}

	.course-management-page .action-btn.edit:hover {
		background: #1E3A8A;
		transform: scale(1.1);
	}

	.course-management-page .action-btn.materials {
		background: #F59E0B;
		color: white;
	}

	.course-management-page .action-btn.materials:hover {
		background: #D97706;
		transform: scale(1.1);
	}

	.course-management-page .action-btn.delete {
		background: #EF4444;
		color: white;
	}

	.course-management-page .action-btn.delete:hover {
		background: #DC2626;
		transform: scale(1.1);
	}

	.course-management-page .course-desc {
		font-size: 14px;
		color: #6B7280;
		line-height: 1.4;
		margin-bottom: 12px;
	}

	.course-management-page .course-stats {
		display: flex;
		gap: 16px;
		font-size: 12px;
		color: #9CA3AF;
	}

	.course-management-page .add-course-item {
		background: #F3F4F6;
		border: 2px dashed #D1D5DB;
		border-radius: 12px;
		padding: 40px 20px;
		text-align: center;
		cursor: pointer;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.course-management-page .add-course-item:hover {
		border-color: #2E5CE6;
		background: rgba(46, 92, 230, 0.05);
	}

	.course-management-page .add-icon {
		font-size: 48px;
		color: #9CA3AF;
		margin-bottom: 12px;
	}

	.course-management-page .add-text {
		font-size: 16px;
		font-weight: 600;
		color: #6B7280;
	}

	.course-management-page .btn {
		padding: 12px 24px;
		border: none;
		border-radius: 12px;
		font-size: 14px;
		font-weight: 600;
		cursor: pointer;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}

	.course-management-page .btn:hover {
		transform: translateY(-2px);
		box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
	}

	.course-management-page .btn:disabled {
		opacity: 0.5;
		cursor: not-allowed;
		transform: none;
		box-shadow: none;
	}

	.course-management-page .btn-primary {
		background: linear-gradient(135deg, #2E5CE6 0%, #D97706 100%);
		color: white;
	}

	.course-management-page .btn-secondary {
		background: #F3F4F6;
		color: #111827;
		border: 1px solid #D1D5DB;
	}

	.course-management-page .modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
		opacity: 0;
		visibility: hidden;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.course-management-page .modal-overlay.show {
		opacity: 1;
		visibility: visible;
	}

	.course-management-page .modal {
		background: white;
		border-radius: 24px;
		box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
		width: 90%;
		max-width: 600px;
		max-height: 90vh;
		overflow-y: auto;
		transform: translateY(20px);
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.course-management-page .modal-overlay.show .modal {
		transform: translateY(0);
	}

	.course-management-page .modal::-webkit-scrollbar {
		width: 6px;
	}

	.course-management-page .modal::-webkit-scrollbar-track {
		background: transparent;
	}

	.course-management-page .modal::-webkit-scrollbar-thumb {
		background: #D1D5DB;
		border-radius: 3px;
	}

	.course-management-page .modal::-webkit-scrollbar-thumb:hover {
		background: #9CA3AF;
	}

	.course-management-page .modal-header {
		padding: 24px 24px 0 24px;
		border-bottom: 1px solid #E5E7EB;
		margin-bottom: 24px;
	}

	.course-management-page .modal-title {
		font-size: 20px;
		font-weight: 700;
		color: #111827;
		margin-bottom: 8px;
	}

	.course-management-page .modal-subtitle {
		font-size: 14px;
		color: #6B7280;
		margin-bottom: 16px;
	}

	.course-management-page .modal-body {
		padding: 0 24px;
	}

	.course-management-page .modal-footer {
		padding: 24px;
		border-top: 1px solid #E5E7EB;
		display: flex;
		gap: 12px;
		justify-content: flex-end;
	}

	.course-management-page .form-group {
		margin-bottom: 20px;
	}

	.course-management-page .form-label {
		display: block;
		font-size: 14px;
		font-weight: 600;
		margin-bottom: 6px;
		color: #111827;
	}

	.form-el-select {
		width: 100%;
	}

	/deep/.form-el-select .el-input__inner {
		border-radius: 12px;
		padding: 12px 16px;
		border: 2px solid #E5E7EB;
		height: 47px;
	}

	.course-management-page .form-input,
	.course-management-page .form-select,
	.course-management-page .form-textarea {
		width: 100%;
		padding: 12px 16px;
		border: 2px solid #E5E7EB;
		border-radius: 12px;
		font-size: 14px;
		font-family: inherit;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		background: white;
	}

	.course-management-page .form-input:focus,
	.course-management-page .form-select:focus,
	.course-management-page .form-textarea:focus {
		outline: none;
		border-color: #2E5CE6;
		box-shadow: 0 0 0 3px rgba(46, 92, 230, 0.1);
	}

	.course-management-page .form-textarea {
		resize: vertical;
		min-height: 100px;
	}

	.course-management-page .upload-area {
		border: 2px dashed #D1D5DB;
		border-radius: 16px;
		padding: 32px;
		text-align: center;
		background: #F9FAFB;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		cursor: pointer;
		margin-bottom: 16px;
	}

	.course-management-page .upload-area:hover {
		border-color: #2E5CE6;
		background: rgba(46, 92, 230, 0.02);
	}

	.course-management-page .upload-icon {
		font-size: 48px;
		color: #9CA3AF;
		margin-bottom: 16px;
	}

	.course-management-page .upload-text {
		font-size: 16px;
		font-weight: 600;
		color: #111827;
		margin-bottom: 8px;
	}

	.course-management-page .upload-hint {
		font-size: 12px;
		color: #6B7280;
		margin-bottom: 16px;
	}

	.course-management-page .file-list {
		margin-top: 16px;
	}

	.course-management-page .file-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
		background: #F3F4F6;
		border: 1px solid #E5E7EB;
		border-radius: 8px;
		margin-bottom: 8px;
	}

	.course-management-page .file-info {
		display: flex;
		align-items: center;
		gap: 12px;
		flex: 1;
	}

	.course-management-page .file-icon {
		font-size: 20px;
	}

	.course-management-page .file-name {
		font-size: 14px;
		font-weight: 500;
		color: #111827;
	}

	.course-management-page .file-size {
		font-size: 12px;
		color: #6B7280;
	}

	.course-management-page .file-remove {
		background: none;
		border: none;
		font-size: 18px;
		color: #EF4444;
		cursor: pointer;
		padding: 4px;
		border-radius: 4px;
		transition: all 0.2s ease;
	}

	.course-management-page .file-remove:hover {
		background: rgba(239, 68, 68, 0.1);
		color: #DC2626;
	}
</style>